//import {AmplifyConfig} from 'aws-amplify/src/Common/types/types';

const awsconfig = {
  aws_appsync_graphqlEndpoint: process.env.VUE_APP_HUB_APPSYNC_ENDPOINT ?? "",
  aws_appsync_region: process.env.VUE_APP_HUB_APPSYNC_REGION ?? "",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  Auth: {
    region: process.env.VUE_APP_HUB_USER_POOL_REGION ?? "",
    identityPoolId: process.env.VUE_APP_HUB_IDENTITY_POOL_ID ?? "",
    userPoolId: process.env.VUE_APP_HUB_USER_POOL_ID ?? "",
    userPoolWebClientId: process.env.VUE_APP_HUB_USER_POOL_CLIENT_ID ?? "",
    //mandatorySignIn: true,
    //authenticationFlowType: 'USER_SRP_AUTH',
    oauth: {
      domain: process.env.VUE_APP_HUB_USER_POOL_CLIENT_DOMAIN,
      scope: [
        "phone",
        "email",
        "openid",
        "profile",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: process.env.VUE_APP_COGNITO_CALLBACK_URI,
      redirectSignOut: process.env.VUE_APP_CONGITO_SIGNOUT_URI,
      //redirectSignOut: "http://localhost:8081,https://dev-hub-console.devqa-1stgrp.com",
      responseType: "code",
    } /*,
        cookieStorage: {
            domain: process.env.VUE_APP_COOKIE_DOMAIN ?? "https://1stgrp.com",
            secure: process.env.NODE_ENV == 'development' ? false : true,
            expires: process.env.VUE_APP_COOKIE_EXPIRY ? Number(process.env.VUE_APP_COOKIE_EXPIRY) : 7
        }*/,
  },
};

export default awsconfig;
